<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer';

const { isMrbilit } = useWhiteLabel();
const route = useRoute();
const afterOrder = computed(() => route.path.includes('/after-order'));
</script>

<template>
    <div>
        <SiteHeader show-back class="site-header">
            <template v-if="afterOrder" #mobile-right-icon>
                <div class="empty-right-icon" />
            </template>
        </SiteHeader>
        <slot />
        <SiteFooter :class="{ 'site-footer': afterOrder }" />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>

<style lang="scss" scoped>
.hide-header-in-mobile {
    @include mobile-only {
        .site-header :deep(header) {
            display: none;
        }
    }
}

.app-web-view {
    .site-footer {
        display: none;
    }
}
.empty-right-icon {
    width: 45px;
}
</style>
